// Significance thresholds. Canonical for the report UI + Cardify
// per decision A (2026-07-13): identical to Cardify
// (`helpers/cardify/config/statThresholds.json`) so the two features agree.
//
// The backend `xtab_stat_sig` Excel export uses a DIFFERENT method (two-tailed,
// alpha 0.05, n>=20, non-directional). That divergence is intentional for this
// first cut and its reconciliation is tracked separately in INSRV-9125.

export const statThresholds = {
  /** One-tailed significance level (default when no confidence is selected). */
  alpha: 0.1,
  /** Columns/cells with a base below this are suppressed (no letter). */
  lowBaseSize: 30,
} as const;

// user-selectable confidence for report-table significance.
// One-tailed (decision C): alpha = 1 - confidence. Ordered for the selector.
// Spec (INSRV-9196) default is 95% (alpha 0.05) — note this differs from
// Cardify's fixed 90%, which is intentional per the report spec.
export const SIGNIFICANCE_CONFIDENCE_LEVELS = [
  { alpha: 0.1, label: '90%' },
  { alpha: 0.05, label: '95%' },
  { alpha: 0.01, label: '99%' },
] as const;

export const DEFAULT_SIGNIFICANCE_ALPHA = 0.05;
